exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  background-color: rgb(47, 59, 78);\n  padding: 0 30px;\n  box-sizing: border-box;\n  color: white;\n}\n\nnav > * { flex: 1; }\nnav > div { display: flex; align-items: center; }\nnav > div h1 { cursor: pointer; }\n\nnav img {\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  margin: 0 20px 0 0;\n}\n\nnav h1 {\n  color: white;\n  font-size: 1.4em;\n}\n\nnav a {\n  color: rgba(180, 200, 255, 0.7);\n  font-size: 1.4em;\n  cursor: pointer;\n}\n\nnav div.right { display: flex; justify-content: flex-end; }\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/Navbar/main.css
// module id = 776
// module chunks = 0